import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import type { Icon } from '@onefootprint/icons';
import { cx } from 'class-variance-authority';
import type { JSX } from 'react';
type FeedbackIconProps = {
  imageIcon: {
    component: Icon;
    color?: Color;
  };
  statusIndicator: {
    component: JSX.Element;
    status: 'loading' | 'error' | 'success';
    backgroundColor?: 'primary' | 'secondary';
  };
};
const FeedbackIcon = t0 => {
  const $ = _c(15);
  const {
    imageIcon: t1,
    statusIndicator: t2
  } = t0;
  const {
    component: ImageIcon,
    color: imageIconColor
  } = t1;
  const {
    component: statusIndicatorComponent,
    status,
    backgroundColor: t3
  } = t2;
  const backgroundColor = t3 === undefined ? "primary" : t3;
  let t4;
  if ($[0] !== ImageIcon || $[1] !== imageIconColor) {
    t4 = <ImageIcon color={imageIconColor} />;
    $[0] = ImageIcon;
    $[1] = imageIconColor;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = backgroundColor === "primary" ? "border-primary" : "border-secondary";
  const t6 = status === "loading" && "bg-warning";
  const t7 = status === "error" && "bg-error";
  const t8 = status === "success" && "bg-success";
  let t9;
  if ($[3] !== t5 || $[4] !== t6 || $[5] !== t7 || $[6] !== t8) {
    t9 = cx("absolute flex justify-center -right-5 -bottom-3 border-4 border-solid rounded-full p-1", t5, t6, t7, t8);
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== status || $[9] !== statusIndicatorComponent || $[10] !== t9) {
    t10 = <div className={t9} data-status={status}>{statusIndicatorComponent}</div>;
    $[8] = status;
    $[9] = statusIndicatorComponent;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t4) {
    t11 = <div className="relative w-10 h-10 p-1">{t4}{t10}</div>;
    $[12] = t10;
    $[13] = t4;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  return t11;
};
export default FeedbackIcon;